import { Injectable } from '@angular/core';
import { User } from '../models/data.types'
import { ApiService } from './api.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map'
import { tokenNotExpired } from 'angular2-jwt';
import { environment } from '../../environments/environment'
import { RequestOptions } from '@angular/http';

@Injectable()
export class AuthenticationService {

    baseUrl: string;
    FindUserUrl: string;
    options :any;

    constructor(private http: HttpClient,private apiService: ApiService) { 
        
        this.baseUrl = environment.apiUrl;
        this.FindUserUrl = `${this.baseUrl}service/api/Account/AuthenticateUser`;
        this.options = new RequestOptions({ withCredentials: true });
    }

    login(username: string, password: string) {

    return this.apiService.userLogin(username, password).map(x => 
        
        {
            let user = localStorage.getItem('currentUser');
        
        if (user != null) {
                return user;
        }
            else
        {
           let user : User = new User();
            user.username = username;
            user.password = password;
            return user;
        }
      });
    }

    logout() {
        localStorage.clear();
    }

    public getToken(): string {

        let currentUser : User;
        currentUser = JSON.parse(localStorage.getItem('currentUser'));

        if(currentUser == null)
        {
            // this.http.get(this.FindUserUrl, this.options).
            // toPromise().
            // then
            // (
            //     x => 
            //     console.log(x)
            // ).
            // catch(this.handleError);
            return "";
        }
        return currentUser.token;
      }

    public getUser(): User {

        let currentUser : User;
        currentUser = JSON.parse(localStorage.getItem('currentUser'));

        if(currentUser == null)
        {
            return null;
            // this.http.get(this.FindUserUrl, this.options).
            //  toPromise().
            //  then
            //  (
            //      x => 
            //      console.log(x)
            //  ).
            //  catch(this.handleError);
        }
        return currentUser;
      }

    public setToken(token: string) {

        let currentUser : User;
        currentUser = JSON.parse(localStorage.getItem('currentUser'));

        if(currentUser != null)
        {
            currentUser.token = token;
            localStorage.setItem('currentUser', JSON.stringify(currentUser));
        }
      }

    public isAuthenticated(): boolean {
        // get the token
        const token = this.getToken();
        // return a boolean reflecting 
        // whether or not the token is expired
        return tokenNotExpired(null, token);
      }

    private handleError(error: any) {
        console.error('An error occurred', error);
        return Promise.reject(error);
    }

     
}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts